<template>
    <div>
        <b-row>
            <b-col sm="12" md="12" lg="12" xl="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">Checklist de Documentos</span>
                    </b-card-header>
                    <b-card-body>
                        <b-row class="pb-2">
                            <b-col v-if="!convenio.cklF02804">
                                <strong>Relatório Físico (Mod F028/04) </strong>
                                <strong
                                    class="fa fa-window-close fa-lg icon-button"
                                    style="color: red"
                                ></strong>
                            </b-col>
                            <b-col v-if="convenio.cklF02804">
                                <strong>Relatório Físico (Mod F028/04) </strong>
                                <strong
                                    class="fa fa-check-square fa-lg"
                                    style="color: #3adf00"
                                ></strong>
                            </b-col>
                            <b-col v-if="!convenio.cklF02805">
                                <strong>Demonst Sintético (Mod F028/05)</strong>
                                <strong class="fa fa-print fa-lg icon-button" @click.stop="imprimir(1)"></strong>
                                <strong class="fa fa-window-close fa-lg icon-button" style="color: red"></strong>
                                <strong class="fa fa-cloud-download  fa-lg icon-button ml-2"
                                    @click="DownloadDocumentoAssinado('F02805')" title="Download do Relatório (F28/05) Assinado"></strong>
                            </b-col>
                            <b-col v-if="convenio.cklF02805">
                                <strong>Demonst Sintético (Mod F028/05)</strong>
                                <strong class="fa fa-print fa-lg icon-button" @click.stop="imprimir(1)"></strong>
                                <strong class="fa fa-check-square fa-lg" style="color: #3adf00"></strong>
                                <strong class="fa fa-cloud-download  fa-lg icon-button ml-2"
                                    @click="DownloadDocumentoAssinado('F02805')" title="Download do Relatório (F28/05) Assinado"></strong>
                            </b-col>

                            <b-col v-if="!convenio.cklF02806">
                                <strong>Rel de Pagamentos SEBRAE (Mod F028/06)</strong>
                                <strong class="fa fa-print fa-lg icon-button" @click.stop="imprimir(2)"></strong>
                                <strong class="fa fa-window-close fa-lg icon-button" style="color: red"></strong>
                                <strong class="fa fa-cloud-download  fa-lg icon-button ml-2"
                                @click="DownloadDocumentoAssinado('F02806')" title="Download do Relatório (F28/06) Assinado"></strong>
                                <strong class="fa fa-table  fa-lg icon-button ml-2"
                                @click="RelatorioF02806Excel()" title="Relatório (F28/06) Excel"></strong>
                            </b-col>
                            <b-col v-if="convenio.cklF02806">
                                <strong>Rel de Pagamentos SEBRAE (Mod F028/06)</strong>
                                <strong class="fa fa-print fa-lg icon-button" @click.stop="imprimir(2)"></strong>
                                <strong class="fa fa-check-square fa-lg" style="color: #3adf00"></strong>
                                <strong class="fa fa-cloud-download  fa-lg icon-button ml-2"
                                    @click="DownloadDocumentoAssinado('F02806')" title="Download do Relatório (F28/06) Assinado">
                                </strong>
                                 <strong class="fa fa-table  fa-lg icon-button ml-2"
                                    @click="RelatorioF02806Excel()" title="Relatório (F28/06) Excel">
                                </strong>
                            </b-col>
                        </b-row>
                        <b-row class="pb-2">
                            <b-col v-if="!convenio.cklF02807">
                                <strong>Rel de Pagamentos Parceiros (Mod F028/07)</strong>
                                <strong class="fa fa-print fa-lg icon-button" @click.stop="imprimir(3)"></strong>
                                <strong class="fa fa-window-close fa-lg icon-button" style="color: red"></strong>
                                <strong class="fa fa-cloud-download  fa-lg icon-button ml-2"
                                @click="DownloadDocumentoAssinado('F02807')" title="Download do Relatório (F28/07) Assinado"></strong>
                            <strong class="fa fa-table  fa-lg icon-button ml-2"
                                @click="RelatorioF02807Excel()" title="Relatório (F28/07) Em Excel"></strong>
                           
                            </b-col>


                            <b-col v-if="convenio.cklF02807">
                                <strong>Rel de Pagamentos Parceiros (Mod F028/07)</strong>
                                <strong class="fa fa-print fa-lg icon-button" @click.stop="imprimir(3)"></strong>
                                <strong class="fa fa-check-square fa-lg" style="color: #3adf00"></strong>
                                <strong class="fa fa-cloud-download  fa-lg icon-button ml-2"
                                    @click="DownloadDocumentoAssinado('F02807')" title="Download do Relatório (F28/07) Assinado"></strong>
                          <strong class="fa fa-table  fa-lg icon-button ml-2"
                                      @click="RelatorioF02807Excel()" title="Relatório (F28/07) Em Excel"></strong>
                          
                                </b-col>

                            <b-col v-if="!convenio.cklF02808">
                                <strong>Rel Despesas Econômicas Parceiros (ModF028/08)</strong>
                                <strong class="fa fa-print fa-lg icon-button" @click.stop="imprimir(5)"></strong>
                                <strong class="fa fa-window-close fa-lg icon-button" style="color: red"></strong>
                                <strong class="fa fa-cloud-download  fa-lg icon-button ml-2"
                                    @click="DownloadDocumentoAssinado('F02808')" title="Download do Relatório (F28/08) Assinado"></strong>
                            </b-col>
                            <b-col v-if="convenio.cklF02808">
                                <strong>Rel Despesas Econômicas Parceiros (Mod F028/08)</strong>
                                <strong class="fa fa-print fa-lg icon-button" @click.stop="imprimir(5)"></strong>
                                <strong class="fa fa-check-square fa-lg" style="color: #3adf00"></strong>
                                <strong class="fa fa-cloud-download  fa-lg icon-button ml-2"
                                    @click="DownloadDocumentoAssinado('F02808')" title="Download do Relatório (F28/08) Assinado"></strong>
                            </b-col>

                            <b-col v-if="!convenio.cklF02809">
                                <strong>Declaração Compras Contratações (Mod.F028/09)</strong>
                                <strong class="fa fa-window-close fa-lg icon-button" style="color: red"></strong>
                                <strong class="fa fa-print fa-lg icon-button"
                                    @click.stop="imprimir(10)">
                                </strong>
                            </b-col>

                            <b-col v-if="convenio.cklF02809">
                                <strong>Declaração Compras Contratações (Mod.F028/09)</strong>
                                <strong class="fa fa-check-square fa-lg" style="color: #3adf00"></strong>
                                <strong class="fa fa-print fa-lg icon-button"
                                    @click.stop="imprimir(10)">
                                </strong>
                            </b-col>
                        </b-row>
                        <b-row class="pb-2">
                            <b-col v-if="!convenio.cklExtratoBancario">
                                <strong> Análise de Prestação de Contas </strong>
                                <strong class="fa fa-print fa-lg icon-button" @click.stop="imprimir(4)"></strong>
                                <strong class="fa fa-window-close fa-lg icon-button" style="color: red"></strong>
                            </b-col>
                            <b-col v-if="convenio.cklExtratoBancario">
                                <strong> Análise de Prestação de Contas </strong>
                                <strong class="fa fa-print fa-lg icon-button" @click.stop="imprimir(4)"></strong>
                                <strong class="fa fa-check-square fa-lg" style="color: #3adf00"></strong>
                            </b-col>

                            <b-col v-if="!convenio.cklExtratoBancarioAplFinanceira">
                                <strong>Extratos Bancários </strong>
                                <strong class="fa fa-window-close fa-lg icon-button" style="color: red"></strong>
                            </b-col>

                            <b-col v-if="convenio.cklExtratoBancarioAplFinanceira">
                                <strong>Extratos Bancários </strong>
                                <strong class="fa fa-check-square fa-lg" style="color: #3adf00"></strong>
                            </b-col>

                            <b-col v-if="!convenio.cklAporteRecParceiros">
                                <strong>Declaração de Aporte de Recursos de Parceiro</strong>
                                <strong class="fa fa-print fa-lg icon-button" @click.stop="imprimir(9)"></strong>
                                <strong class="fa fa-window-close fa-lg icon-button" style="color: red"></strong>
                            </b-col>
                            <b-col v-if="convenio.cklAporteRecParceiros">
                                <strong>Declaração de Aporte de Recursos de Parceiro</strong>
                                <strong class="fa fa-print fa-lg icon-button" @click.stop="imprimir(9)"></strong>
                                <strong class="fa fa-check-square fa-lg" style="color: #3adf00"></strong>
                            </b-col>
                        </b-row>
                        <b-row class="pb-2">
                            <b-col >
                                <strong>Declaração de Atesto</strong>
                                <strong class="fa fa-cloud-download  fa-lg icon-button ml-2"
                                    @click="DownloadDocumentoAssinado('F02810')"title="Download da Declaração de Atesto Assinado"></strong>
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>

        <b-card no-body>
            <b-card-header>
                <span class="h5"> Prestação de Contas Final  </span>
            </b-card-header>
            <b-card-body>
                <div>
                    <app-tabela :itens="lista" :campos="campos" :itensPorPagina="itensPorPagina" :bordered="false"
                        :small="false">
                        :small="false">
                        <template slot="botoes" slot-scope="data">
                            <b-button-group class="float-right">
                                <Cadastro v-if="$temAcessoView('CONV-FIN-01') && convenio.idSituacaoConvenio != 9"
                                    class="mr-2" @atualizarCadastro="atualizarCadastro()" :parentData="convenio"
                                    :documento="data" :modoCadastro="true">
                                </Cadastro>
                            </b-button-group>
                        </template>
                        <template slot="acoes" slot-scope="data">
                            <span class="text-danger float-left mr-1">
                                <i class="fa fa-trash fa-lg icon-button" title="Excluir Documento"
                                    v-if="$temAcessoView('CONV-00') && convenio.idSituacaoConvenio != 9"
                                    @click.stop="confirmarExclusao(data)"></i>
                            </span>
                            <b-button-group>
                                <span class="text-primary float-right">
                                    <visualizar-documentos :parentData="convenio" :documento="data">
                                    </visualizar-documentos>
                                </span>
                            </b-button-group>
                            <span class="text-primary float-left">
                                <Cadastro class="mr-2"
                                    v-if="$temAcessoView('CONV-FIN-02') && convenio.idSituacaoConvenio != 9"
                                    @atualizarCadastro="atualizarCadastro()" :parentData="convenio"
                                    :modoCadastro="false" :documento="data">
                                </Cadastro>
                            </span>
                        </template>
                    </app-tabela>
                </div>
            </b-card-body>
        </b-card>

        <b-modal id="modalDoc" size="xl" v-model="mostrarModal" no-close-on-backdrop style="height: 50%; margin: 0">
            <div slot="modal-title">Visualizar Documentos - {{ nomeDoc }}</div>
            <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
            <iframe v-if="arquivo" v-bind:src="arquivo" style="width: 100%; height: 600px">
            </iframe>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()">
                    Fechar
                </b-button>
                <b-button variant="secondary" @click.stop="fecharModal()">
                    Fechar
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import ConveniosServicos from '../ConveniosServicos'
import Cadastro from '../cadastro/BtnDocumentoPrestacaoContasFinal.vue'
import VisualizarDocumentos from '../cadastro/VisualizarDocumentosPrestacoesFinais'

export default {
    components: {
        Cadastro,
        VisualizarDocumentos
    },

    props: {
        convenio: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            erros: [],
            itensPorPagina: 5,
            lista: [],

            mostrarModal: false,
            arquivo: [],
            nomeDoc: '',

            campos: [
                {
                    key: 'documentoPrestacaoContas.descricao',
                    label: 'Documento',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'vcObservacoes',
                    label: 'Observação',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'acoes',
                    label: ''
                }
            ]
        }
    },

    methods: {
        fecharModal() {
            this.mostrarModal = false
            this.arquivo = null
        },

        atualizarLista() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.ListarDocumentoPrestacaoContasConvenio(
                this.convenio.idConvenio
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.lista = response.data
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmarExclusao(obj) {
            this.$swal({
                title: 'Excluir',
                html:
                    'Deseja Excluir o Documento: <strong>' +
                    obj.documentoPrestacaoContas.descricao +
                    '</strong> ?',
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.excluir(obj)
                }
            })
        },
        excluir(obj) {
            this.$store.dispatch('addRequest')
            ConveniosServicos.DeletarDocumentoPrestacaoContasConvenio(obj).then(
                (response) => {
                    if (response) {
                        this.$emit('atualizarDadosConvenio')
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },
        atualizarCadastro() {
            this.$emit('atualizarDadosConvenio')
        },
        async DownloadDocumentoAssinado(tipoRelatorio) {
            await ConveniosServicos.downloadDocumentoAssinado(
                this.convenio.idConvenio, tipoRelatorio
            ).then((response) => {
                if (response.type === 'application/json') {
                    this.$toast.error(
                        `Relatório ${tipoRelatorio} referente ao Convênio ${this.convenio.vcCodigoEstruturado} não foi encontrado assinado !!!`,
                        'ERROR',
                        this.$toastConfig.error
                    )
                } else {
                    this.visualizar(response, `Relatório ${tipoRelatorio}`)
                }
                this.$store.dispatch('removeRequest')
            })
        },

        imprimir(id) {
            if (id == 1) {
                this.RelatorioF02805()
            } else if (id == 2) {
                this.RelatorioF02806()
            } else if (id == 3) {
                this.RelatorioF02807()
            } else if (id == 4) {
                this.RelatorioExtratoPrestacaoContas()
            } else if (id == 5) {
                this.RelatorioF02808()
            } else if (id == 9) {
                this.RelatorioAporteRecursosParceiro()
            } else if (id == 10) {
                this.RelatorioF02809()
            }
        },

        RelatorioF02805() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.RelatorioF02805DemonstrativoExecucaoSintetico(
                this.convenio.idConvenio,
                1
            ).then((response) => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro ao emitir relatório!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        this.visualizar(response, 'Relatorio F028/05')
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },


        RelatorioF02806() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.RelatorioF02806RelacaoPagamentosEfetuados(
                this.convenio.idConvenio,
                1
            ).then((response) => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro ao emitir relatório!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                         
                        this.visualizar(response, 'Relatorio F028/06')
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
        RelatorioF02806Excel() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.RelatorioF02806RelacaoPagamentosEfetuados(
                this.convenio.idConvenio,
                2
            ).then((response) => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro ao emitir relatório!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                         this.$download(response, 'Relatorio F028/06.xlsx')
                        //this.visualizar(response, 'Relatorio F028/06')
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },


        RelatorioF02807() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.RelatorioF2807RelacaoPagamentosEfetuadosRecursosParceiro(
                this.convenio.idConvenio,
                1
            ).then((response) => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro ao emitir relatório!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        this.visualizar(response, 'Relatorio F028/07')
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
        RelatorioF02807Excel() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.RelatorioF2807RelacaoPagamentosEfetuadosRecursosParceiro(
                this.convenio.idConvenio,
                2
            ).then((response) => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro ao emitir relatório!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                         this.$download(response, 'Relatorio F028/07.xlsx')
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },


        RelatorioExtratoPrestacaoContas() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.RelatorioExtratoPrestacaoContas(
                this.convenio.idConvenio,
                1
            ).then((response) => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro ao emitir relatório!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        this.visualizar(
                            response,
                            'Relatorio Extrato de Prestação de Contas'
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        RelatorioF02808() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.RelatorioF02808RelDespesasEconomicasParceiros(this.convenio.idConvenio, 1).then((response) => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro ao emitir relatório!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        this.visualizar(response, 'Relatorio F028/08')
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        RelatorioF02809() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.RelatorioF02809DeclaracaoDeLicitacao(this.convenio.idConvenio, 1).then((response) => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro ao emitir relatório!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        this.visualizar(response, 'Relatorio F028/09')
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        RelatorioAporteRecursosParceiro() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.relatorioAporteRecursosParceiro(this.convenio.idConvenio, 1).then((response) => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro ao emitir relatório!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        this.visualizar(response, 'Declaração de Aporte de Recursos de Parceiro')
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
        
        RelatorioF02808() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.RelatorioF02808RelDespesasEconomicasParceiros(this.convenio.idConvenio, 1).then((response) => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro ao emitir relatório!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        this.visualizar(response, 'Relatorio F028/08')
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        visualizar(doc, nome) {
            this.nomeDoc = nome
            const blob = new Blob([doc], { type: 'application/pdf' })
            this.arquivo = window.URL.createObjectURL(blob)
            this.mostrarModal = true
        }
    },

    watch: {
        convenio() {
            if (this.convenio) {
                this.atualizarLista()
            }
        }
    }
}
</script>
